import { AxiosError } from 'axios';
import { useMutation, useQueryClient, UseMutationOptions } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { DELETE_URL } from '@utils/api/endpoints.ts';
import { QueryKeys } from '@utils/api/query-keys.ts';
import { BaseError } from '@utils/types/shared/base.ts';

interface DeleteExportTemplateItemResponse {
  success: boolean;
}

export const useDeleteExportTemplateItem = (
  options?: UseMutationOptions<
    DeleteExportTemplateItemResponse,
    AxiosError<BaseError>,
    number
  >
) => {
  const queryClient = useQueryClient();

  return useMutation<
    DeleteExportTemplateItemResponse,
    AxiosError<BaseError>,
    number
  >(
    async (itemId: number) => {
      const url = DELETE_URL(itemId.toString()).deleteExportTemplateItem;
      const { data } =
        await Axios.delete<DeleteExportTemplateItemResponse>(url);
      return data;
    },
    {
      onSuccess: () => {
        // Invalidate the export template items list
        queryClient.invalidateQueries(QueryKeys.exportTemplateItems());
      },
      ...options
    }
  );
};
